import type { Category } from '../config';
import { RefProvider } from '../config';
import { getProviderConfig } from 'config/providers';
import { VendorApp } from 'config/vendors';
import {
  initModalystStore,
  initZendropStore,
  initAutoDSStore,
  setupModalystProducts,
  setupZendropProducts,
  setupAutoDSProducts,
} from './endpoints';

export const initStoreByProvider: Record<RefProvider, (category: Category) => Promise<void>> = {
  [RefProvider.Standalone]: initModalystStore,
  [RefProvider.StoreBuilder]: initModalystStore,
  // todo remove with feature flag
  [RefProvider.ZenDrop]: (category) =>
    getProviderConfig().vendor === VendorApp.ZenDrop ? initZendropStore(category) : initModalystStore(category),
  [RefProvider.AutoDS]: initAutoDSStore,
};

export const setupProductsByProvider: Record<RefProvider, (category: Category) => Promise<void>> = {
  [RefProvider.Standalone]: setupModalystProducts,
  [RefProvider.StoreBuilder]: setupModalystProducts,
  // todo remove with feature flag
  [RefProvider.ZenDrop]: (category) =>
    getProviderConfig().vendor === VendorApp.ZenDrop ? setupZendropProducts(category) : setupModalystProducts(category),
  [RefProvider.AutoDS]: setupAutoDSProducts,
};
